"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridEmptyData = void 0;

const jsx_runtime_1 = require("react/jsx-runtime");

const styles_1 = require("./styles");

const Icons_1 = require("../Icons");

const GridEmptyData = props => {
  const {
    emptyData
  } = props;
  return (0, jsx_runtime_1.jsx)(styles_1.StyledEmptyData, {
    children: (0, jsx_runtime_1.jsxs)(styles_1.StyledEmptyDataIcon, {
      children: [(0, jsx_runtime_1.jsx)(styles_1.StyledEmptyDataIcon, {
        children: (0, jsx_runtime_1.jsx)(Icons_1.Meh, {}, void 0)
      }, void 0), emptyData !== null && emptyData !== void 0 ? emptyData : (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
        children: [(0, jsx_runtime_1.jsx)(styles_1.StyledEmptyDataFirst, {
          children: "No results to this filter"
        }, void 0), (0, jsx_runtime_1.jsx)(styles_1.StyledEmptyDataSecond, {
          children: " please try other one"
        }, void 0)]
      }, void 0)]
    }, void 0)
  }, void 0);
};

exports.GridEmptyData = GridEmptyData;